import { createSlice } from "@reduxjs/toolkit";

const slice = createSlice({
    name: "authenticationSlice",
    initialState: {
        loginData: "",
        token: sessionStorage.getItem("token"),
        role: sessionStorage.getItem("role"),
        user: sessionStorage.getItem("user"),
        id: sessionStorage.getItem("id"),
        userId: sessionStorage.getItem("userId"),
        rolePermissions: sessionStorage.getItem("rolePermissions"),
        // nav: sessionStorage.getItem("nav"),
        // loggedIn: sessionStorage.getItem("loggedIn"),
    },
    reducers: {
        LOGIN_SUCCESS: (state, action) => {
            return {
                ...state,
                loginData: action.payload,
                token: sessionStorage.getItem("token"),
                role: sessionStorage.getItem("role"),
                user: sessionStorage.getItem("user"),
                employee_id: sessionStorage.getItem("employee_id"),
                uuid: sessionStorage.getItem("uuid"),
                userId: sessionStorage.getItem("userId"),
                rolePermissions: sessionStorage.getItem("rolePermissions"),
                // nav: sessionStorage.getItem("nav"),
            };
        },
        LOGIN_ERROR: (state) => {
            return {
                ...state,
                loginData: "",
                token: "",
                role: "",
                user: "",
                employee_id: "",
                loggedIn: "",
                uuid: "",
                userId: "",
                rolePermissions: "",
                // nav:"",
            };
        },
    },
});

export const { LOGIN_SUCCESS, LOGIN_ERROR } = slice.actions;
export default slice.reducer;
